var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocksIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.088,
    height: 25.249,
    viewBox: "0 0 17.088 25.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "locks-icon-active",
    transform: "translate(0.625 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M16.588,47.456H.75V35.468a3.85,3.85,0,0,1,3.85-3.85h8.138a3.85,3.85,0,0,1,3.85,3.85Z",
    transform: "translate(-0.75 -23.456)",
    fill: "none",
    stroke: "#d63f94",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M8.741,9.2V6.536a5.786,5.786,0,1,1,11.572,0V9.429",
    transform: "translate(-6.628 -0.75)",
    fill: "none",
    stroke: "#d63f94",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M25.875,50.064a2.475,2.475,0,1,0-3.965,1.973v3.252H24.89V52.037A2.468,2.468,0,0,0,25.875,50.064Z",
    transform: "translate(-15.591 -35.204)",
    fill: "none",
    stroke: "#d63f94",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocksIconActive);
export default __webpack_public_path__ + "static/media/locks-icon-active.7552e056c677da95595cb957a113cffa.svg";
export { ForwardRef as ReactComponent };